import script from "./FormFrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"

import "./FormFrequenciaEncontro.vue?vue&type=style&index=0&id=ae67acec&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae67acec"]])

export default __exports__